//@ts-nocheck
import React from "react";
import { Menu, Layout as ELayout } from "element-react";
import EditorSideBar from "./editorSideBar";
const EditorLayout = (props) => {
  return (
    <ELayout.Row className="admin-layout">
      {/* <ELayout.Col span={4}>
        <EditorSideBar {...props} />
      </ELayout.Col> */}
      <ELayout.Col span={24}>
        <div className="admin-container">{props.children}</div>
      </ELayout.Col>
    </ELayout.Row>
  );
};

export default EditorLayout;
